import { FunctionComponent } from 'react'
import DeactiveAccount from './desactiveAccount/deactiveAccount'
import styles from './account.module.scss'
import ChangeEmailAccount from './changeEmailAccount/changeEmailAccount'
import DeactiveNotificationAccount from './desactiveNotificationAccount/deactiveNotificationAccount'
import ActiveNotificationAccount from './activeNotificationAccount/activeNotificationAccount'

const AccountSettings: FunctionComponent = () => {
    return (
        <div className={styles.AccountPlacement}>
            <div className={styles.Container}>
                <DeactiveAccount />
            </div>
            <div className={styles.Container}>
                <ChangeEmailAccount />
            </div>
            <div className={styles.Container}>
                <DeactiveNotificationAccount />
            </div>
            <div className={styles.Container}>
                <ActiveNotificationAccount />
            </div>
        </div>
    )
}

export default AccountSettings
